import React, { Fragment } from 'react';
import { Trans } from 'react-i18next';
import { MASTER_DATA, USERS, JOBS } from 'src/routes/routes';
import { withRouter, Link } from 'react-router-dom';
import { userAuthorization } from 'src/utils/auth';
import { AuditorDashboardWidget } from './Dashboards/AuditorDashboardWidget/AuditorDashboardWidget';
import {
  MasterDataManagerDashboard,
  AdministratorDashboard,
  MainDashboard,
  ReportReviewerDashboard,
  CapManagerDashboard,
  FactoryUserDashboard,
  JobsSummaryDashboard,
  UserDashboardSaqJob,
} from './Dashboards';
import s from './RootPage.styles';

const RootPage = () => {
  const currentUserAuth = userAuthorization();

  const dashboards = [
    currentUserAuth.isAdmin ? <AdministratorDashboard /> : null,
    !currentUserAuth.isAdmin && currentUserAuth.isMasterDataManager ? (
      <MasterDataManagerDashboard />
    ) : null,
    currentUserAuth.isAuditor ? <AuditorDashboardWidget /> : null,
    currentUserAuth.isReportReviewer ? <ReportReviewerDashboard /> : null,
    currentUserAuth.isCapManager ? <CapManagerDashboard /> : null,
    currentUserAuth.isFactoryUser ? <FactoryUserDashboard /> : null,
    currentUserAuth.isAdmin ? <JobsSummaryDashboard /> : null,
    currentUserAuth.isAuditor || currentUserAuth.isFactoryUser ? <UserDashboardSaqJob /> : null,
  ].filter(c => !!c);

  if (dashboards.length > 0) {
    return (
      <MainDashboard>
        {dashboards.map((d, index) => (
          <Fragment key={index}>{d}</Fragment>
        ))}
      </MainDashboard>
    );
  }

  return (
    <div>
      <s.Title>
        <Trans>WELCOME</Trans>
      </s.Title>
      <s.Container>
        <Link to={USERS}>
          <s.WhiteBox>
            <s.Icon name="users-big" />
            <s.WhiteBoxText>
              <Trans>USERS</Trans>
            </s.WhiteBoxText>
          </s.WhiteBox>
        </Link>
        <Link to={MASTER_DATA}>
          <s.WhiteBox>
            <s.Icon name="masterdata-big" />
            <s.WhiteBoxText>
              <Trans>MASTER_DATA</Trans>
            </s.WhiteBoxText>
          </s.WhiteBox>
        </Link>
        <Link to={JOBS}>
          <s.WhiteBox>
            <s.Icon name="jobs-big" />
            <s.WhiteBoxText>
              <Trans>JOBS</Trans>
            </s.WhiteBoxText>
          </s.WhiteBox>
        </Link>
      </s.Container>
    </div>
  );
};

export default React.memo(withRouter(RootPage));
